export const urls = window.env.urls;

